import { TeamRoleOption } from "@rogoag/airtable";
import { ProagricaAuth } from "../api/common";
import { UserSettings } from "../utilities/types";

export type Role = TeamRoleOption | "Customer";

export interface IUser {
	id: string;
	name: string;
	token: string;
	username: string;
	email: string;
	fullName: string;
	disabled: boolean;
	companyIds: string[];
	companyIdsAll: string[];
	portalSettings: UserSettings;
	portalImportOptions: string[];
	roles: Role[];
	proagricaAuth?: ProagricaAuth;
}

export class User implements IUser {
	constructor(
		public id: string,
		public name: string,
		public token: string,
		public username: string,
		public email: string,
		public fullName: string,
		public disabled: boolean,
		public companyIds: string[],
		public companyIdsAll: string[],
		public portalSettings: UserSettings,
		public portalImportOptions: string[],
		public roles: Role[],
		public proagricaAuth?: ProagricaAuth,
	) {}

	static fromIUser(data: IUser, token?: string): User {
		return new User(
			data.id,
			data.name,
			token ?? data.token,
			data.username,
			data.email,
			data.fullName,
			data.disabled,
			data.companyIds,
			data.companyIdsAll,
			data.portalSettings,
			data.portalImportOptions,
			data.roles,
			data.proagricaAuth,
		);
	}

	get isDeveloper() {
		return this.roles.includes("Developer");
	}

	get isAdmin() {
		return this.roles.includes("App admin") || this.isDeveloper;
	}

	get isOfficePersonnel() {
		return this.roles.includes("Office") || this.isDeveloper;
	}

	get isMapmaker() {
		return this.roles.includes("Mapmaker") || this.isDeveloper;
	}

	get isCustomer() {
		return this.roles.includes("Customer") || this.isDeveloper;
	}

	get isSalesperson() {
		return this.roles.includes("Sales") || this.isDeveloper;
	}
}
